import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { cookingStoryPageCategories } from 'src/app/core/model/api-response/cooking-story-model';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { RecipeShared } from '../../general/shared/recipe-shared';

@Component({
  selector: 'app-cooking-story-home',
  templateUrl: './cooking-story-home.component.html',
  styleUrls: ['./cooking-story-home.component.scss'],
})
export class CookingStoryHomeComponent implements OnInit, OnDestroy {
  suggestPost: cookingStoryPageCategories;
  subscription1: Subscription;
  constructor(
    private recipeService: RecipeService,
    private groceryApiService: CookingStoryGroceryApiService,
    private recipeShared: RecipeShared
  ) {
    this.subscription1 = this.recipeShared.recipeTabSelectedObs$.subscribe(
      (selected) => {
        if (selected) {
          this.groceryApiService.getkitchenSuggestion().then((data) => {
            if (data.isSuccess()) {
              this.suggestPost = data.getData().getkitchenSuggestion().kitchen;
            }
          });
        }
      }
    );
  }
  showCategory(type: string, name: string) {
    this.recipeService.goToCategory(this.suggestPost._id, type, name);
  }
  ngOnInit(): void {}
  goTobook() {
    this.recipeService.goToCookingStoryBook();
  }
  goToKitchen(type: 'shoppinglist' | 'kitchen') {
    this.recipeService.goToKitchen(type);
  }
  goToMeMbers() {
    this.recipeService.goToHomeMembers();
  }
  ngOnDestroy() {
    this.subscription1.unsubscribe();
  }
}
